var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 52,
    viewBox: "0 0 35 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5938 7.07812H28.2812H27.2031H2.40625C1.22031 7.07812 0.25 8.13281 0.25 9.42188V49.2656C0.25 50.5547 1.22031 51.6094 2.40625 51.6094H32.5938C33.7797 51.6094 34.75 50.5547 34.75 49.2656V9.42188C34.75 8.13281 33.7797 7.07812 32.5938 7.07812Z",
    fill: "#444C63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5156 11.7656V46.9219C31.5156 47.5078 30.9766 48.0938 30.4375 48.0938H4.5625C4.02344 48.0938 3.48438 47.5078 3.48438 46.9219V11.7656C3.48438 11.1797 4.02344 10.5938 4.5625 10.5938H30.4375C30.9766 10.5938 31.5156 11.1797 31.5156 11.7656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 24.6562L14.2656 36.375L8.875 30.5156L11.0312 28.1719L14.2656 31.6875L23.9688 22.3125L26.125 24.6562Z",
    fill: "#23C16B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8125 4.73438C21.8125 1.92187 20.0875 0.046875 17.5 0.046875C14.9125 0.046875 13.1875 1.92187 13.1875 4.73438H7.79688V7.07812V12.9375H27.2031V7.07812V4.73438H21.8125ZM17.5 6.49219C16.6375 6.49219 15.8828 5.67188 15.8828 4.73438C15.8828 3.79688 16.6375 2.97656 17.5 2.97656C18.3625 2.97656 19.1172 3.79688 19.1172 4.73438C19.1172 5.67188 18.3625 6.49219 17.5 6.49219Z",
    fill: "#FFB533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2031 9.65625H7.79688V12.9375H27.2031V9.65625Z",
    fill: "#FFD05C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.929343b7048e1d39cdfea1cf058d83a0.svg";
export { ForwardRef as ReactComponent };